import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";

import Confetti from "./Confetti";
import { Signal } from "signals";


export default class ConfettiAnim extends PIXI.Container
{
    private _duration: number = null;
    private _confettiCountMult: number = null;
    private _confettiCreateMult: number = null;
    private _speedYMult: number = null;
    private _frontContainer: PIXI.Container = null;

    private _back: PIXI.Container = null;
    private _front: PIXI.Container = null;
    private _arrBackConfetti: Array<Confetti> = null;
    private _arrFrontConfetti: Array<Confetti> = null;
    private _backElapsedTime: number = null;
    private _frontElapsedTime: number = null;

    private _state: state_type = null;
    private _elapsedTime: number = null;

    private _onCompleted: Signal = null;


    public set duration( value: number ) { this._duration = value; }
    public set confettiCountMult( value: number ) { this._confettiCountMult = value; }
    public set confettiCreateMult( value: number ) { this._confettiCreateMult = value; }
    public set speedYMult( value: number ) { this._speedYMult = value; }
    public set frontContainer( value: PIXI.Container ) { this._frontContainer = value; }

    public get onCompleted(): Signal { return this._onCompleted; }


    public constructor() 
    {
        super();
    }

    public init(): void
    {
        if ( this._confettiCountMult === null )
        {
            this._confettiCountMult = 1;
        }
        if ( this._confettiCreateMult === null )
        {
            this._confettiCreateMult = 2;
        }
        if ( this._speedYMult === null )
        {
            this._speedYMult = 1;
        }
        this._arrBackConfetti = [];
        this._arrFrontConfetti = [];
        this._backElapsedTime = 10;
        this._frontElapsedTime = 10;
        this._state = state_type.PLAYING;

        this._back = new PIXI.Container();
        this._back.y = -ServiceLocator.app.safeAreaMarginY - 90;
        this.addChild( this._back );
        //
        this._front = new PIXI.Container();
        this._front.y = -ServiceLocator.app.safeAreaMarginY - 90;
        if ( !this._frontContainer )
        {
            this.addChild( this._front );
        }
        else
        {
            this._frontContainer.addChild( this._front );
        }

        if ( this._duration !== null )
        {
            this._elapsedTime = 0;
            
            this._onCompleted = new Signal();
        }
    }

    public update( dt: number ): void
    {
        if ( this._state == state_type.COMPLETED ) { return; }

        if ( this._state == state_type.PLAYING )
        {
            if ( this._duration !== null )
            {
                this._elapsedTime += dt;
                if ( this._elapsedTime >= this._duration )
                {
                    this._state = state_type.STOPPED;
                }
            }
        }

        if ( this._state == state_type.PLAYING )
        {
            this._backElapsedTime += dt;
            if ( this._backElapsedTime > 0.5 * this._confettiCreateMult )
            {
                const kConfettiCount: number = ( Math.floor( Math.random() * 10 * 0.5 ) + 2 ) * this._confettiCountMult;
                let isLeftSide: boolean = true; 
                for ( let i: number = 0; i < kConfettiCount; ++i )
                {
                    let offsetX: number = -ServiceLocator.app.safeAreaWidth * 0.5 * Math.random();
                    let speed: PIXI.Point = new PIXI.Point();
                    speed.y = ( Math.random() * 100 + 200 ) * this._speedYMult;
                    speed.x = Math.random() * 50;
                    let angularSpeed: number = Math.random() * 90 + 180;
                    if ( !isLeftSide )
                    {
                        speed.x = -speed.x;
                        angularSpeed = -angularSpeed;
                        offsetX = -offsetX;
                    }
                    const kSpriteId: string = "confetti_" + ( Math.floor( Math.random() * 39 ) );
                    let confetti: Confetti = new Confetti( kSpriteId, speed, angularSpeed );
                    confetti.position.set( ServiceLocator.app.width * 0.5 + offsetX, 0 );
                    this._back.addChild( confetti );

                    this._arrBackConfetti.push( confetti );

                    isLeftSide = !isLeftSide;
                }

                this._backElapsedTime = 0;
            }
        }

        const kRemoveY: number = ServiceLocator.app.safeAreaHeight + 90;
        for ( let i: number = this._arrBackConfetti.length - 1; i >= 0; --i )
        {
            let confetti: Confetti = this._arrBackConfetti[ i ];
            if ( confetti.y > kRemoveY )
            {
                confetti.parent.removeChild( confetti );
                this._arrBackConfetti.splice( i, 1 );
            }
            else
            {
                confetti.update( dt );
            }
        }

        if ( this._state == state_type.PLAYING )
        {
            this._frontElapsedTime += dt;
            if ( this._frontElapsedTime > 1 * this._confettiCreateMult )
            {
                const kConfettiCount: number = ( Math.floor( Math.random() * 2 * 0.5 ) + 2 ) * this._confettiCountMult;
                let isLeftSide: boolean = true; 
                for ( let i: number = 0; i < kConfettiCount; ++i )
                {
                    let offsetX: number = -ServiceLocator.app.safeAreaWidth * 0.5 * Math.random();
                    let speed: PIXI.Point = new PIXI.Point();
                    speed.y = ( Math.random() * 100 + 200 ) * 2 * this._speedYMult;
                    speed.x = Math.random() * 50;
                    let angularSpeed: number = ( Math.random() * 90 + 180 ) * 1.5;
                    if ( !isLeftSide )
                    {
                        speed.x = -speed.x;
                        angularSpeed = -angularSpeed;
                        offsetX = -offsetX;
                    }
                    const kSpriteId: string = "confetti_" + ( Math.floor( Math.random() * 39 ) );
                    let confetti: Confetti = new Confetti( kSpriteId, speed, angularSpeed );
                    confetti.scale.set( confetti.scale.x * 2 );
                    confetti.position.set( ServiceLocator.app.width * 0.5 + offsetX, 0 );
                    this._front.addChild( confetti );

                    this._arrFrontConfetti.push( confetti );

                    isLeftSide = !isLeftSide;
                }

                this._frontElapsedTime = 0;
            }
        }

        const kFrontRemoveY: number = ServiceLocator.app.safeAreaHeight + 180;
        for ( let i: number = this._arrFrontConfetti.length - 1; i >= 0; --i )
        {
            let confetti: Confetti = this._arrFrontConfetti[ i ];
            if ( confetti.y > kFrontRemoveY )
            {
                confetti.parent.removeChild( confetti );
                this._arrFrontConfetti.splice( i, 1 );
            }
            else
            {
                confetti.update( dt );
            }
        }

        if ( this._arrBackConfetti.length == 0 && this._arrFrontConfetti.length == 0 )
        {
            this._onCompleted.dispatch();
        }
    }

    public end(): void
    {
        if ( this._onCompleted )
        {
            this._onCompleted.dispose();
            this._onCompleted = null;
        }

        this._back.parent.removeChild( this._back );
        this._back.destroy( { children: true } );
        this._back = null;

        this._front.parent.removeChild( this._front );
        this._front.destroy( { children: true } );
        this._front = null;
    }
}

const enum state_type
{
    PLAYING = 0,
    STOPPED,
    COMPLETED
}